export const showPortalButtonKey = "show-hmb-portal-login";
export const drawerWidth = "85%";
export const emptyGuid = "00000000-0000-0000-0000-000000000000";
